import Module from "utilities/global/sparta-module-utility/6.3.0/js/sparta-module-utility";
import ahCawCommons from "utilities/login/ah-caw-commons-utility/2.4.1/js/ah-caw-commons-utility";
import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import handlebarsRuntime from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import hb from "utilities/vendor/handlebars-runtime/4.7.7/js/handlebars.runtime";
import spartaStyleUtility from "utilities/global/sparta-style-utility/3.2.4/js/sparta-style-utility";
import cawEventsMasterUtility from "utilities/login/ah-caw-events-master-utility/4.5.3/js/ah-caw-events-master-utility";
import spartaTemplates from "modules/login/ah-caw-footer-module/6.2.1/js/templates";
import "css!modules/login/ah-caw-footer-module/6.2.1/css/ah-caw-footer-module.scss.css";


export function blah() {
  alert('blah');
}

export function blah2() {
  const versions = {
    jquery: $.fn.jquery,
    lodash: _.VERSION,
    handlebars: hb.VERSION,
  };

  alert(JSON.stringify(versions));
}
